/**
 * DE wachtwoordregel van de webshop (registreren, account na afrekenen, nieuw wachtwoord via de
 * herstelmail, wachtwoord instellen of wijzigen in Mijn gegevens).
 *
 * Volgt NIST SP 800-63B in plaats van "minstens één hoofdletter en een cijfer":
 * - lengte telt, samenstellingsregels niet (die leveren "Welkom01!" op);
 * - geen bovengrens die lange wachtzinnen blokkeert (alleen een ruim maximum tegen misbruik);
 * - wél een lijst met wachtwoorden die altijd als eerste geprobeerd worden;
 * - nooit je eigen e-mailadres of naam.
 *
 * De backend controleert hetzelfde én checkt gelekte wachtwoorden (Have I Been Pwned,
 * k-anonimiteit). Dat hoort op de server: daar kan het niet omzeild worden.
 */

export const PASSWORD_MIN = 8
export const PASSWORD_MAX = 128

export const PASSWORD_HINT = `Minstens ${PASSWORD_MIN} tekens. Een korte zin werkt prima.`

/** De meest geprobeerde wachtwoorden, plus wat bij deze site voor de hand ligt. Kleine letters. */
const COMMON = new Set([
  '12345678',
  '123456789',
  '1234567890',
  '87654321',
  '11111111',
  '00000000',
  'password',
  'password1',
  'wachtwoord',
  'wachtwoord1',
  'welkom01',
  'welkom123',
  'qwertyui',
  'qwerty123',
  'iloveyou',
  'abcdefgh',
  'beautybewust',
  'skincare',
])

type Context = { email?: string; firstName?: string }

/** Geeft de klanttekst terug als het wachtwoord niet goed genoeg is, anders `null`. */
export function passwordProblem(password: string, { email, firstName }: Context = {}): string | null {
  if (password.length < PASSWORD_MIN) return `Kies een wachtwoord van minstens ${PASSWORD_MIN} tekens.`
  if (password.length > PASSWORD_MAX) return `Een wachtwoord mag hoogstens ${PASSWORD_MAX} tekens zijn.`
  const lower = password.trim().toLowerCase()
  if (COMMON.has(lower) || /^(.)\1+$/.test(lower)) return 'Dit wachtwoord wordt vaak geraden. Kies iets persoonlijkers, een korte zin werkt goed.'
  const localPart = email?.trim().toLowerCase().split('@')[0]
  if ((email && lower === email.trim().toLowerCase()) || (localPart && localPart.length >= 4 && lower === localPart))
    return 'Gebruik niet je e-mailadres als wachtwoord.'
  if (firstName && lower === firstName.trim().toLowerCase()) return 'Gebruik niet je naam als wachtwoord.'
  return null
}
